var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contextual-help",attrs:{"id":_vm.title ? 'help-' + _vm.title : ''}},[_c('md-icon',[_vm._v("help")]),_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.expandedText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }